export default __webpack_public_path__ + "static/media/hotel2ndfloormap.7d9d4b89.png";